import { render, staticRenderFns } from "./IntroOutroElementOverview.vue?vue&type=template&id=0b53d7f6&"
import script from "./IntroOutroElementOverview.vue?vue&type=script&lang=js&"
export * from "./IntroOutroElementOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports